module.exports = __webpack_public_path__ + "img/s9limg1.f10052a8.png";